import React ,{Component} from "react";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import {Col, Container, Row} from "react-bootstrap";


class Checkout extends Component {
    render() {
        return (
            <div>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main className="main-bg">
                    <header className="work-header">
                        <Container className="mt-80">
                            <Row>
                                <Col lg={8}>
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>پرداخت</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </header>

                    <section className="shop-checkout section-padding pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="order-form md-mb50">
                                        <h4 className="mb-40">مشخصات پرداخت</h4>
                                        <form
                                            action="https://ui-themez.smartinnovates.net/items/geekfolio/dark/contact.php">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">نام *</label>
                                                        <input type="text" name="first_name" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">نام خانوادگی *</label>
                                                        <input type="text" name="last_name" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">آدرس ایمیل *</label>
                                                        <input type="email" name="email" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="">شماره تلفن *</label>
                                                        <input type="text" name="phone" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="">شهر *</label>
                                                        <input type="text" name="city" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="">منطقه *</label>
                                                        <input type="text" name="area" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="">کد پستی *</label>
                                                        <input type="text" name="postal_code" required />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label htmlFor="">آدرس *</label>
                                                        <input type="text" name="address" required />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-5 offset-lg-1">
                                    <div className="checkout-order-info">
                                        <h4 className="mb-40">سفارش شما</h4>
                                        <div>
                                            <ul className="rest">
                                                <li className="mb-5">
                                                    <div className="d-flex align-items-center">
                                                        <div>
                                                            <p>قیمت پایه مزایده</p>
                                                        </div>
                                                        <div className="ml-auto">
                                                            <h5 className="fz-18">650,000,000 تومان</h5>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="pt-10 bord-thin-top">
                                                    <div className="d-flex align-items-center">
                                                        <div>
                                                            <h6>جمع کل</h6>
                                                        </div>
                                                        <div className="ml-auto">
                                                            <h5 className="main-color fz-20">650,000,000 تومان</h5>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="pt-10 bord-thin-top bord-thin-bottom">
                                                    <div className="d-flex align-items-center">
                                                        <div>
                                                            <h6>قیمت نهایی</h6>
                                                        </div>
                                                        <div className="ml-auto">
                                                            <h5 className="main-color fz-20">650,000,000 تومان</h5>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div className="mt-30">
                                                <button type="submit"
                                                        className="butn butn-md butn-bg main-colorbg2 text-dark">
                                                    <span className="text-u fw-600">تایید و پرداخت</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </div>
        );
    }
}

export default Checkout;
